import React, { useEffect, useState } from "react";
import {
  IconPackage,
  IconShoppingCart,
  IconReceipt,
  IconFileInvoice,
  IconFileDescription,
  IconBox,
  IconAlertCircle,
  IconBoxOff,
  IconRefreshDot,
  IconTrash,
} from "@tabler/icons-react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import {
  Button,
  Col,
  Spinner,
  Badge,
  InputGroup,
  Form,
  Row,
  FormGroup,
  Table,
} from "react-bootstrap";
import ComanConfirmationModal from "../../components/ComanConfirmationModal";
import { useNavigate } from "react-router-dom";

function UpdateProductsPopup({
  skuId,
  productId,
  setShow,
  show,
  onDeleteSuccess,
}) {
  const [productInfo, setProductInfo] = useState(null);
  const [newSkuId, setNewSkuId] = useState("");
  const [newProductName, setNewProductName] = useState("");
  const [newSkuIdReal, setNewSkuIdReal] = useState("");
  const [newSkuDisplay, setNewSkuDisplay] = useState("");
  const [skuSuggestions, setSkuSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [isModalStatusOpen, setIsModalStatusOpen] = useState({
    show: false,
    action: null,
    message: "",
  });
  const navigate = useNavigate();

  const { postData: fetchSkuSuggestions } = usePostRequest(
    API_ENDPOINTS.PRODUCT_SUGGETION,
  );

  const { isLoading: prodLoading, postData: getProducts } = usePostRequest(
    API_ENDPOINTS.GET_PRODUCTS_INFO,
  );

  const { isLoading: updating, postData: updateProds } = usePostRequest(
    API_ENDPOINTS.UPDATE_PRODUCT_INFO,
  );

  const { isLoading: deleting, postData: deleteProd } = usePostRequest(
    API_ENDPOINTS.DELETE_PRODUCT,
  );

  useEffect(() => {
    if (skuId && productId) {
      getProducts({ sku_id: skuId, product_id: productId }, onSuccess, onError);
    }
  }, [refreshTrigger]);

  const openModal = (method) => {
    const isDelete = method === "delete";
    setIsModalStatusOpen({
      show: true,
      action: isDelete ? "Delete" : "Update",
      message: `Are you sure you want to ${isDelete ? "delete" : "update"} product ${productInfo?.sku_display_name}?`,
      onConfirm: isDelete ? handleDeleteProduct : handleUpdate,
      title: isDelete ? "Delete Product" : "Update Product",
      icon: isDelete ? <IconTrash stroke={1} /> : <IconRefreshDot stroke={1} />,
      type: isDelete ? "danger" : "success",
    });
  };

  const handleDeleteProduct = () => {
    deleteProd(
      { sku_id: productInfo?.sku_id, product_id: productInfo?.product_id },
      onSuccessDelete,
      onErrorDelete,
    );
  };

  const onSuccessDelete = (res) => {
    toast.success(res?.message || "Product deleted successfully");
    onDeleteSuccess?.();
    setShow({ show: false });
  };

  const onErrorDelete = (err) => {
    toast.error(
      err?.message ||
        "Encountered some error while deleting the product, please try again.",
    );
  };

  const handleSuggestionSelect = (product) => {
    setNewSkuIdReal(product?.sku_id);
    setNewSkuDisplay(product?.sku_display_name)
    setNewSkuId(product?.sku_display_name);
    setNewProductName(product?.name || "");
    setShowSuggestions(false);
    setSkuSuggestions([]);
  };

  useEffect(() => {
    if (!newSkuId || newSkuIdReal) return;
    const timer = setTimeout(() => {
      fetchSkuSuggestions(
        { page: 1, limit: 10, sku: newSkuId, module_type: "RFQ" },
        (data) => {
          setSkuSuggestions(data?.data || []);
          setShowSuggestions(true);
        },
      );
    }, 500);
    return () => clearTimeout(timer);
  }, [newSkuId]);

  const onSuccess = (res) => setProductInfo(res);
  const onError = (err) =>
    toast.error(err?.message || "Failed to fetch product information.");

  const onUpdateSuccess = () => {
    toast.success("Product updated successfully.");
    setRefreshTrigger((prev) => prev + 1);
  };

  const onUpdateError = (err) =>
    toast.error(err?.message || "Failed to update product.");

  const handleUpdate = () => {
    updateProds(
      {
        old_sku_id: productInfo?.sku_id,
        new_sku_id: newSkuIdReal || newSkuId,
        sku_display_name: newSkuDisplay,
        name: newProductName,
        product_id: productInfo?.product_id,
      },
      onUpdateSuccess,
      onUpdateError,
    );
  };

  // const SECTION_CONFIG = [
  //   {
  //     key: "Order",
  //     label: "Orders",
  //     icon: IconShoppingCart,
  //     color: "#3b82f6",
  //     bgColor: "#eff6ff",
  //   },
  //   {
  //     key: "Opportunity",
  //     label: "Opportunities",
  //     icon: IconFileInvoice,
  //     color: "#f59e0b",
  //     bgColor: "#fffbeb",
  //   },
  //   {
  //     key: "Contract Vehicle",
  //     label: "Contract Vehicles",
  //     icon: IconFileDescription,
  //     color: "#8b5cf6",
  //     bgColor: "#f5f3ff",
  //   },
  //   {
  //     key: "product_kits",
  //     label: "Product Kits",
  //     icon: IconBox,
  //     color: "#ec4899",
  //     bgColor: "#fdf2f8",
  //   },
  // ];

  const SECTION_CONFIG = [
    {
      key: "Order",
      label: "Orders",
      icon: IconShoppingCart,
      color: "#3b82f6",
      bgColor: "#eff6ff",
      getRoute: (id) => `/edit-order/${id}`,
    },
    {
      key: "Opportunity",
      label: "Opportunities",
      icon: IconFileInvoice,
      color: "#f59e0b",
      bgColor: "#fffbeb",
      getRoute: (id) => `/edit-rfq/${id}`,
    },
    {
      key: "Contract Vehicle",
      label: "Contract Vehicles",
      icon: IconFileDescription,
      color: "#8b5cf6",
      bgColor: "#f5f3ff",
      getRoute: (id) => `/edit-contract-vehicle/${id}`,
    },
    {
      key: "product_kits",
      label: "Product Kits",
      icon: IconBox,
      color: "#ec4899",
      bgColor: "#fdf2f8",
      getRoute: (id) => `/update-product/${id}`,
    },
  ];

  const totalUsage = productInfo
    ? SECTION_CONFIG.reduce(
        (acc, { key }) => acc + (productInfo.usage?.[key]?.count || 0),
        0,
      )
    : 0;

  return (
    <>
      <ComanConfirmationModal
        show={isModalStatusOpen.show}
        onHide={() => {
          setIsModalStatusOpen({ ...isModalStatusOpen, show: false });
          // setIsOpen(false);
        }}
        title={isModalStatusOpen.title}
        message={isModalStatusOpen.message}
        onConfirm={isModalStatusOpen.onConfirm}
        icon={isModalStatusOpen.icon}
        type={isModalStatusOpen.type}
      />

      <Modal
        scrollable
        show={show}
        onHide={() => setShow({ show: false })}
        dialogClassName="modal-90w update-products-modal"
        size="lg"
        centered
      >
        <style>{`
        .update-products-modal .modal-content {
          border: none;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
        }
    
        .update-products-modal .modal-title {
          font-size: 22px;
          font-weight: 700;
          color: #1a1a1a;
          letter-spacing: -0.3px;
        }
    
        .update-products-modal .modal-body {
          padding: 28px 32px;
          background: #fafafa;
        }
        .update-products-modal .modal-footer {
          background: #ffffff;
          border-top: 1px solid #f0f0f0;
          padding: 16px 32px;
        }
        .sku-card {
          background: linear-gradient(135deg, #ffffff 0%, #fff8f0 100%);
          border: 1px solid #ffe4cc;
          border-radius: 12px;
          padding: 20px 24px;
          margin-bottom: 24px;
          position: relative;
          overflow: hidden;
        }
        .sku-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 4px;
          height: 100%;
          background: linear-gradient(180deg, #f59e0b, #ea580c);
        }
        .sku-card-header {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 14px;
        }
        .sku-card-title {
          font-size: 11px;
          font-weight: 700;
          color: #ea580c;
          letter-spacing: 1.2px;
          text-transform: uppercase;
          margin: 0;
        }
        .sku-field-label {
          font-size: 11px;
          color: #94a3b8;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          display: block;
          margin-bottom: 4px;
        }
        .sku-field-value {
          font-size: 16px;
          color: #1e293b;
          font-weight: 600;
          margin: 0;
        }
        .summary-banner {
          background: #fff;
          border: 1px solid #e2e8f0;
          border-radius: 10px;
          padding: 12px 18px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .summary-banner-text {
          font-size: 13px;
          color: #64748b;
          font-weight: 500;
          margin: 0;
        }
        .summary-banner-count {
          font-size: 20px;
          font-weight: 700;
          color: #ea580c;
        }
        .usage-card {
          background: #ffffff;
          border: 1px solid #e9ecef;
          border-radius: 12px;
          padding: 18px 20px;
          margin-bottom: 12px;
          transition: all 0.25s ease;
        }
        .usage-card:hover {
          border-color: #d1d5db;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
        }
        .usage-card-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
        }
        .usage-card-title-wrap {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .usage-icon-box {
          width: 38px;
          height: 38px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .usage-card-label {
          font-size: 14px;
          font-weight: 600;
          color: #1e293b;
          margin: 0;
        }
        .usage-count-badge {
          font-size: 11px;
          font-weight: 700;
          padding: 4px 10px;
          border-radius: 20px;
          color: #fff;
          min-width: 26px;
          text-align: center;
        }
        .usage-ids-wrap {
          padding-left: 50px;
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
        }
        .usage-id-chip {
          background: #f1f5f9;
          color: #475569;
          font-size: 12px;
          font-weight: 500;
          padding: 4px 10px;
          border-radius: 6px;
          border: 1px solid #e2e8f0;
        }
        .usage-id-empty {
          color: #cbd5e1;
          font-size: 12px;
          font-style: italic;
        }
        .empty-state {
          text-align: center;
          padding: 40px 20px;
          color: #94a3b8;
        }
        .loading-wrap {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
          padding: 60px 20px;
        }
        .loading-text {
          color: #94a3b8;
          font-size: 13px;
          font-weight: 500;
        }
        .btn-cancel-custom {
          border: 1.5px solid #e2e8f0 !important;
          color: #64748b !important;
          background: #fff !important;
          font-weight: 600;
          padding: 8px 24px;
          border-radius: 8px;
          transition: all 0.2s ease;
        }
        .btn-cancel-custom:hover {
          background: #f8fafc !important;
          border-color: #cbd5e1 !important;
          color: #1e293b !important;
        }
        .header-subtitle {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .usage-id-chip:hover {
          background: #e2e8f0;
          border-color: #94a3b8;
          color: #1e293b;
        }
      `}</style>

        <Modal.Header closeButton>
          <div className="w-100 text-center">
            <Modal.Title>Update Products</Modal.Title>
            <p className="header-subtitle">
              <IconAlertCircle size={14} />
              Review where this SKU is being used within the CRM and update
              accordingly
            </p>
          </div>
        </Modal.Header>

        <Modal.Body>
          {prodLoading ? (
            <div className="loading-wrap">
              <Spinner animation="border" style={{ color: "#ea580c" }} />
              <span className="loading-text">
                Loading product information...
              </span>
            </div>
          ) : productInfo ? (
            <>
              {/* Existing SKU Card */}
              <div className="sku-card">
                <div className="sku-card-header">
                  <IconPackage size={16} color="#ea580c" />
                  <p className="sku-card-title">Existing SKU</p>
                </div>
                <Row>
                  <Col md={4} className="mb-2 mb-md-0">
                    <span className="sku-field-label">SKU ID</span>
                    <p className="sku-field-value">
                      {productInfo.sku_display_name ?? "N/A"}
                    </p>
                  </Col>
                  <Col md={4}>
                    <span className="sku-field-label">Product Name</span>
                    <p className="sku-field-value">
                      {productInfo.name ?? "N/A"}
                    </p>
                  </Col>
                  <Col md={4}>
                    {/* {totalUsage > 0 && ( */}
                    <>
                      <span className="sku-field-label">
                        Total references found across CRM
                      </span>
                      <p className="sku-field-value summary-banner-count">
                        {totalUsage}
                      </p>
                    </>
                    {/* )} */}
                  </Col>
                </Row>
              </div>

              {/* Usage Sections */}
              {totalUsage === 0 ? (
                <div className="empty-state">
                  <IconBoxOff size={48} stroke={1.2} />
                  <p className="mt-3 mb-0">This SKU is not in use anywhere.</p>
                </div>
              ) : (
                SECTION_CONFIG.map(
                  ({
                    key,
                    label,
                    icon: Icon,
                    color,
                    bgColor,
                    getRoute,
                    getDisplayId,
                  }) => {
                    const section = productInfo.usage?.[key];
                    if (!section || section.count === 0) return null;

                    const ids = section.data.filter(Boolean);

                    return (
                      <div key={key} className="usage-card">
                        <div className="usage-card-header">
                          <div className="usage-card-title-wrap">
                            <div
                              className="usage-icon-box"
                              style={{ background: bgColor }}
                            >
                              <Icon size={20} color={color} />
                            </div>
                            <h6 className="usage-card-label">{label}</h6>
                          </div>
                          <span
                            className="usage-count-badge"
                            style={{ background: color }}
                          >
                            {section.count}
                          </span>
                        </div>
                        <div className="usage-ids-wrap">
                          {ids.length > 0 ? (
                            ids.map((id, idx) => (
                              <span
                                key={idx}
                                className="usage-id-chip"
                                onClick={() => navigate(getRoute(id))}
                                style={{ cursor: "pointer" }}
                              >
                                {id}
                              </span>
                            ))
                          ) : (
                            <span className="usage-id-empty">
                              No reference IDs available
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  },
                )
              )}
              <div className="mt-2 w-100">
                {totalUsage !== 0 && (
                  <div style={{ marginBottom: 16 }}>
                    <h6
                      style={{
                        fontSize: 13,
                        fontWeight: 700,
                        color: "#1e293b",
                        marginBottom: 12,
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                      }}
                    >
                      Update Product
                    </h6>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Form.Label className="sku-field-label">
                            New SKU ID
                          </Form.Label>
                          <InputGroup className="mb-3">
                            <Form.Control
                              name="newSkuId"
                              value={newSkuId}
                              onChange={(e) => {
                                setNewSkuId(e.target.value);
                                setNewSkuIdReal("");
                              }}
                              placeholder="Enter new SKU ID"
                              aria-label="new-sku-id"
                              autoComplete="off"
                              onBlur={() =>
                                setTimeout(() => setShowSuggestions(false), 200)
                              }
                            />
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Form.Label className="sku-field-label">
                            New Product Name
                          </Form.Label>
                          <InputGroup className="mb-3">
                            <Form.Control
                              name="newProductName"
                              value={newProductName}
                              onChange={(e) =>
                                setNewProductName(e.target.value)
                              }
                              placeholder="Enter new product name"
                              aria-label="new-product-name"
                            />
                          </InputGroup>
                        </FormGroup>
                      </Col>
                    </Row>

                    {/* Suggestions box — full width, outside Row */}
                    {showSuggestions && skuSuggestions.length > 0 && (
                      <div
                        className="suggestions_box"
                        style={{ marginTop: -8, marginBottom: 12 }}
                      >
                        <div className="table-responsive">
                          <Table
                            hover
                            size="sm"
                            className="mb-0"
                            style={{ fontSize: 12 }}
                          >
                            <tbody>
                              {skuSuggestions.map((product, idx) => (
                                <tr
                                  key={idx}
                                  style={{ cursor: "pointer" }}
                                  onMouseDown={() =>
                                    handleSuggestionSelect(product)
                                  }
                                >
                                  {/* <td>{product?.Vendor?.display_name}</td> */}
                                  <td>{product?.sku_display_name}</td>
                                  <td>{product?.name}</td>
                                  {/* <td style={{ color: "#94a3b8" }}>
                            {product?.description?.slice(0, 60)}
                          </td>
                          <td>{product?.uoi}</td>
                          <td style={{ color: "#ea580c" }}>
                            ${product?.aspetto_price}
                          </td> */}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className="d-flex justify-content-end gap-2">
                  {totalUsage === 0 ? (
                    <Button
                      variant="warning"
                      onClick={() => openModal("delete")}
                      disabled={deleting}
                    >
                      Delete
                    </Button>
                  ) : (
                    <Button
                      variant="warning"
                      onClick={() => openModal("update")}
                      disabled={updating || !newSkuId || !newProductName}
                    >
                      {updating ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Update"
                      )}
                    </Button>
                  )}
                  <Button
                    className="btn-cancel-custom"
                    onClick={() => setShow({ show: false })}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </>
          ) : (
            <div className="empty-state">
              <IconBoxOff size={48} stroke={1.2} />
              <p className="mt-3 mb-0">No product data available.</p>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
}

export default UpdateProductsPopup;

// import React, { useEffect, useState } from "react";
// import {
//   IconPackage,
//   IconShoppingCart,
//   IconReceipt,
//   IconFileInvoice,
//   IconFileDescription,
//   IconBox,
//   IconAlertCircle,
//   IconBoxOff,
//   IconRefreshDot,
//   IconTrash,
// } from "@tabler/icons-react";
// import Modal from "react-bootstrap/Modal";
// import { toast } from "react-toastify";
// import usePostRequest from "../../hooks/usePostRequest";
// import { API_ENDPOINTS } from "../../constant/_constant";
// import {
//   Button,
//   Col,
//   Spinner,
//   Badge,
//   InputGroup,
//   Form,
//   Row,
//   FormGroup,
//   Table,
// } from "react-bootstrap";
// import ComanConfirmationModal from "../../components/ComanConfirmationModal";

// function UpdateProductsPopup({ skuId, productId, setShow, show, onDeleteSuccess  }) {
//   const [productInfo, setProductInfo] = useState(null);
//   const [newSkuId, setNewSkuId] = useState("");
//   const [newProductName, setNewProductName] = useState("");
//   const [newSkuIdReal, setNewSkuIdReal] = useState("");
//   const [skuSuggestions, setSkuSuggestions] = useState([]);
//   const [showSuggestions, setShowSuggestions] = useState(false);
//   const [refreshTrigger, setRefreshTrigger] = useState(0);
//   const [isModalStatusOpen, setIsModalStatusOpen] = useState({
//     show: false,
//     action: null,
//     message: "",
//   });

//   const { postData: fetchSkuSuggestions } = usePostRequest(
//     API_ENDPOINTS.PRODUCT_SUGGETION,
//   );

//   const { isLoading: prodLoading, postData: getProducts } = usePostRequest(
//     API_ENDPOINTS.GET_PRODUCTS_INFO,
//   );

//   const { isLoading: updating, postData: updateProds } = usePostRequest(
//     API_ENDPOINTS.UPDATE_PRODUCT_INFO,
//   );

//   const { isLoading: deleting, postData: deleteProd } = usePostRequest(
//     API_ENDPOINTS.DELETE_PRODUCT,
//   );

//   useEffect(() => {
//     if (skuId && productId) {
//       getProducts({ sku_id: skuId, product_id: productId }, onSuccess, onError);
//     }
//   }, [refreshTrigger]);

//   const openModal = (method) => {
//     const isDelete = method === "delete";
//     setIsModalStatusOpen({
//       show: true,
//       action: isDelete ? "Delete" : "Update",
//       message: `Are you sure you want to ${isDelete ? "delete" : "update"} product ${productInfo?.sku_display_name}?`,
//       onConfirm: isDelete ? handleDeleteProduct : handleUpdate,
//       title: isDelete ? "Delete Product" : "Update Product",
//       icon: isDelete ? <IconTrash stroke={1} /> : <IconRefreshDot stroke={1} />,
//       type: isDelete ? "danger" : "success",
//     });
//   };

//   const handleDeleteProduct = () => {
//     deleteProd(
//       { sku_id: productInfo?.sku_id, product_id: productInfo?.product_id },
//       onSuccessDelete,
//       onErrorDelete,
//     );
//   };

//   const onSuccessDelete = (res) => {
//     toast.success(res?.message || "Product deleted successfully");
//     onDeleteSuccess?.();
//     setShow({ show: false });
//   };

//   const onErrorDelete = (err) => {
//     toast.error(
//       err?.message ||
//         "Encountered some error while deleting the product, please try again.",
//     );
//   };

//   const handleSuggestionSelect = (product) => {
//     setNewSkuIdReal(product?.sku_id);
//     setNewSkuId(product?.sku_display_name);
//     setNewProductName(product?.name || "");
//     setShowSuggestions(false);
//     setSkuSuggestions([]);
//   };

//   useEffect(() => {
//     if (!newSkuId || newSkuIdReal) return;
//     const timer = setTimeout(() => {
//       fetchSkuSuggestions(
//         { page: 1, limit: 10, sku: newSkuId, module_type: "RFQ" },
//         (data) => {
//           setSkuSuggestions(data?.data || []);
//           setShowSuggestions(true);
//         },
//       );
//     }, 500);
//     return () => clearTimeout(timer);
//   }, [newSkuId]);

//   const onSuccess = (res) => setProductInfo(res);
//   const onError = (err) =>
//     toast.error(err?.message || "Failed to fetch product information.");

//   const onUpdateSuccess = () => {
//     toast.success("Product updated successfully.");
//     setRefreshTrigger((prev) => prev + 1);
//   };

//   const onUpdateError = (err) =>
//     toast.error(err?.message || "Failed to update product.");

//   const handleUpdate = () => {
//     updateProds(
//       {
//         old_sku_id: productInfo?.sku_id,
//         new_sku_id: newSkuIdReal || newSkuId,
//         sku_display_name: productInfo?.sku_display_name,
//         name: newProductName,
//         product_id: productInfo?.product_id,
//       },
//       onUpdateSuccess,
//       onUpdateError,
//     );
//   };

//   const SECTION_CONFIG = [
//     {
//       key: "Order",
//       label: "Orders",
//       icon: IconShoppingCart,
//       color: "#3b82f6",
//       bgColor: "#eff6ff",
//     },
//     {
//       key: "Opportunity",
//       label: "Opportunities",
//       icon: IconFileInvoice,
//       color: "#f59e0b",
//       bgColor: "#fffbeb",
//     },
//     {
//       key: "Contract Vehicle",
//       label: "Contract Vehicles",
//       icon: IconFileDescription,
//       color: "#8b5cf6",
//       bgColor: "#f5f3ff",
//     },
//     {
//       key: "product_kits",
//       label: "Product Kits",
//       icon: IconBox,
//       color: "#ec4899",
//       bgColor: "#fdf2f8",
//     },
//   ];

//   const totalUsage = productInfo
//     ? SECTION_CONFIG.reduce(
//         (acc, { key }) => acc + (productInfo.usage?.[key]?.count || 0),
//         0,
//       )
//     : 0;

//   return (
//     <>
//       <ComanConfirmationModal
//         show={isModalStatusOpen.show}
//         onHide={() => {
//           setIsModalStatusOpen({ ...isModalStatusOpen, show: false });
//           // setIsOpen(false);
//         }}
//         title={isModalStatusOpen.title}
//         message={isModalStatusOpen.message}
//         onConfirm={isModalStatusOpen.onConfirm}
//         icon={isModalStatusOpen.icon}
//         type={isModalStatusOpen.type}
//       />

//       <Modal
//         scrollable
//         show={show}
//         onHide={() => setShow({ show: false })}
//         dialogClassName="modal-90w update-products-modal"
//         size="lg"
//         centered
//       >
//         <style>{`
//         .update-products-modal .modal-content {
//           border: none;
//           border-radius: 16px;
//           overflow: hidden;
//           box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
//         }
    
//         .update-products-modal .modal-title {
//           font-size: 22px;
//           font-weight: 700;
//           color: #1a1a1a;
//           letter-spacing: -0.3px;
//         }
    
//         .update-products-modal .modal-body {
//           padding: 28px 32px;
//           background: #fafafa;
//         }
//         .update-products-modal .modal-footer {
//           background: #ffffff;
//           border-top: 1px solid #f0f0f0;
//           padding: 16px 32px;
//         }
//         .sku-card {
//           background: linear-gradient(135deg, #ffffff 0%, #fff8f0 100%);
//           border: 1px solid #ffe4cc;
//           border-radius: 12px;
//           padding: 20px 24px;
//           margin-bottom: 24px;
//           position: relative;
//           overflow: hidden;
//         }
//         .sku-card::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 4px;
//           height: 100%;
//           background: linear-gradient(180deg, #f59e0b, #ea580c);
//         }
//         .sku-card-header {
//           display: flex;
//           align-items: center;
//           gap: 8px;
//           margin-bottom: 14px;
//         }
//         .sku-card-title {
//           font-size: 11px;
//           font-weight: 700;
//           color: #ea580c;
//           letter-spacing: 1.2px;
//           text-transform: uppercase;
//           margin: 0;
//         }
//         .sku-field-label {
//           font-size: 11px;
//           color: #94a3b8;
//           font-weight: 600;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//           display: block;
//           margin-bottom: 4px;
//         }
//         .sku-field-value {
//           font-size: 16px;
//           color: #1e293b;
//           font-weight: 600;
//           margin: 0;
//         }
//         .summary-banner {
//           background: #fff;
//           border: 1px solid #e2e8f0;
//           border-radius: 10px;
//           padding: 12px 18px;
//           margin-bottom: 20px;
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//         }
//         .summary-banner-text {
//           font-size: 13px;
//           color: #64748b;
//           font-weight: 500;
//           margin: 0;
//         }
//         .summary-banner-count {
//           font-size: 20px;
//           font-weight: 700;
//           color: #ea580c;
//         }
//         .usage-card {
//           background: #ffffff;
//           border: 1px solid #e9ecef;
//           border-radius: 12px;
//           padding: 18px 20px;
//           margin-bottom: 12px;
//           transition: all 0.25s ease;
//         }
//         .usage-card:hover {
//           border-color: #d1d5db;
//           transform: translateY(-1px);
//           box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
//         }
//         .usage-card-header {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           margin-bottom: 10px;
//         }
//         .usage-card-title-wrap {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//         }
//         .usage-icon-box {
//           width: 38px;
//           height: 38px;
//           border-radius: 10px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           flex-shrink: 0;
//         }
//         .usage-card-label {
//           font-size: 14px;
//           font-weight: 600;
//           color: #1e293b;
//           margin: 0;
//         }
//         .usage-count-badge {
//           font-size: 11px;
//           font-weight: 700;
//           padding: 4px 10px;
//           border-radius: 20px;
//           color: #fff;
//           min-width: 26px;
//           text-align: center;
//         }
//         .usage-ids-wrap {
//           padding-left: 50px;
//           display: flex;
//           flex-wrap: wrap;
//           gap: 6px;
//         }
//         .usage-id-chip {
//           background: #f1f5f9;
//           color: #475569;
//           font-size: 12px;
//           font-weight: 500;
//           padding: 4px 10px;
//           border-radius: 6px;
//           border: 1px solid #e2e8f0;
//         }
//         .usage-id-empty {
//           color: #cbd5e1;
//           font-size: 12px;
//           font-style: italic;
//         }
//         .empty-state {
//           text-align: center;
//           padding: 40px 20px;
//           color: #94a3b8;
//         }
//         .loading-wrap {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 12px;
//           padding: 60px 20px;
//         }
//         .loading-text {
//           color: #94a3b8;
//           font-size: 13px;
//           font-weight: 500;
//         }
//         .btn-cancel-custom {
//           border: 1.5px solid #e2e8f0 !important;
//           color: #64748b !important;
//           background: #fff !important;
//           font-weight: 600;
//           padding: 8px 24px;
//           border-radius: 8px;
//           transition: all 0.2s ease;
//         }
//         .btn-cancel-custom:hover {
//           background: #f8fafc !important;
//           border-color: #cbd5e1 !important;
//           color: #1e293b !important;
//         }
//         .header-subtitle {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//         }
//       `}</style>

//         <Modal.Header closeButton>
//           <div className="w-100 text-center">
//             <Modal.Title>Update Products</Modal.Title>
//             <p className="header-subtitle">
//               <IconAlertCircle size={14} />
//               Review where this SKU is being used within the CRM and update
//               accordingly
//             </p>
//           </div>
//         </Modal.Header>

//         <Modal.Body>
//           {prodLoading ? (
//             <div className="loading-wrap">
//               <Spinner animation="border" style={{ color: "#ea580c" }} />
//               <span className="loading-text">
//                 Loading product information...
//               </span>
//             </div>
//           ) : productInfo ? (
//             <>
//               {/* Existing SKU Card */}
//               <div className="sku-card">
//                 <div className="sku-card-header">
//                   <IconPackage size={16} color="#ea580c" />
//                   <p className="sku-card-title">Existing SKU</p>
//                 </div>
//                 <Row>
//                   <Col md={4} className="mb-2 mb-md-0">
//                     <span className="sku-field-label">SKU ID</span>
//                     <p className="sku-field-value">
//                       {productInfo.sku_display_name ?? "N/A"}
//                     </p>
//                   </Col>
//                   <Col md={4}>
//                     <span className="sku-field-label">Product Name</span>
//                     <p className="sku-field-value">
//                       {productInfo.name ?? "N/A"}
//                     </p>
//                   </Col>
//                   <Col md={4}>
//                     {/* {totalUsage > 0 && ( */}
//                     <>
//                       <span className="sku-field-label">
//                         Total references found across CRM
//                       </span>
//                       <p className="sku-field-value summary-banner-count">
//                         {totalUsage}
//                       </p>
//                     </>
//                     {/* )} */}
//                   </Col>
//                 </Row>
//               </div>

//               {/* Usage Sections */}
//               {totalUsage === 0 ? (
//                 <div className="empty-state">
//                   <IconBoxOff size={48} stroke={1.2} />
//                   <p className="mt-3 mb-0">This SKU is not in use anywhere.</p>
//                 </div>
//               ) : (
//                 SECTION_CONFIG.map(
//                   ({
//                     key,
//                     label,
//                     icon: Icon,
//                     color,
//                     bgColor,
//                     getDisplayId,
//                   }) => {
//                     const section = productInfo.usage?.[key];
//                     if (!section || section.count === 0) return null;

//                     const ids = section.data.filter(Boolean);

//                     return (
//                       <div key={key} className="usage-card">
//                         <div className="usage-card-header">
//                           <div className="usage-card-title-wrap">
//                             <div
//                               className="usage-icon-box"
//                               style={{ background: bgColor }}
//                             >
//                               <Icon size={20} color={color} />
//                             </div>
//                             <h6 className="usage-card-label">{label}</h6>
//                           </div>
//                           <span
//                             className="usage-count-badge"
//                             style={{ background: color }}
//                           >
//                             {section.count}
//                           </span>
//                         </div>
//                         <div className="usage-ids-wrap">
//                           {ids.length > 0 ? (
//                             ids.map((id, idx) => (
//                               <span key={idx} className="usage-id-chip">
//                                 {id}
//                               </span>
//                             ))
//                           ) : (
//                             <span className="usage-id-empty">
//                               No reference IDs available
//                             </span>
//                           )}
//                         </div>
//                       </div>
//                     );
//                   },
//                 )
//               )}
//               <div className="mt-2 w-100">
//                 {totalUsage !== 0 && (
//                   <div style={{ marginBottom: 16 }}>
//                     <h6
//                       style={{
//                         fontSize: 13,
//                         fontWeight: 700,
//                         color: "#1e293b",
//                         marginBottom: 12,
//                         textTransform: "uppercase",
//                         letterSpacing: "0.5px",
//                       }}
//                     >
//                       Update Product
//                     </h6>
//                     <Row>
//                       <Col md={6}>
//                         <FormGroup>
//                           <Form.Label className="sku-field-label">
//                             New SKU ID
//                           </Form.Label>
//                           <InputGroup className="mb-3">
//                             <Form.Control
//                               name="newSkuId"
//                               value={newSkuId}
//                               onChange={(e) => {
//                                 setNewSkuId(e.target.value);
//                                 setNewSkuIdReal("");
//                               }}
//                               placeholder="Enter new SKU ID"
//                               aria-label="new-sku-id"
//                               autoComplete="off"
//                               onBlur={() =>
//                                 setTimeout(() => setShowSuggestions(false), 200)
//                               }
//                             />
//                           </InputGroup>
//                         </FormGroup>
//                       </Col>
//                       <Col md={6}>
//                         <FormGroup>
//                           <Form.Label className="sku-field-label">
//                             New Product Name
//                           </Form.Label>
//                           <InputGroup className="mb-3">
//                             <Form.Control
//                               name="newProductName"
//                               value={newProductName}
//                               onChange={(e) =>
//                                 setNewProductName(e.target.value)
//                               }
//                               placeholder="Enter new product name"
//                               aria-label="new-product-name"
//                             />
//                           </InputGroup>
//                         </FormGroup>
//                       </Col>
//                     </Row>

//                     {/* Suggestions box — full width, outside Row */}
//                     {showSuggestions && skuSuggestions.length > 0 && (
//                       <div
//                         className="suggestions_box"
//                         style={{ marginTop: -8, marginBottom: 12 }}
//                       >
//                         <div className="table-responsive">
//                           <Table
//                             hover
//                             size="sm"
//                             className="mb-0"
//                             style={{ fontSize: 12 }}
//                           >
//                             <tbody>
//                               {skuSuggestions.map((product, idx) => (
//                                 <tr
//                                   key={idx}
//                                   style={{ cursor: "pointer" }}
//                                   onMouseDown={() =>
//                                     handleSuggestionSelect(product)
//                                   }
//                                 >
//                                   {/* <td>{product?.Vendor?.display_name}</td> */}
//                                   <td>{product?.sku_display_name}</td>
//                                   <td>{product?.name}</td>
//                                   {/* <td style={{ color: "#94a3b8" }}>
//                             {product?.description?.slice(0, 60)}
//                           </td>
//                           <td>{product?.uoi}</td>
//                           <td style={{ color: "#ea580c" }}>
//                             ${product?.aspetto_price}
//                           </td> */}
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </Table>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 )}
//                 <div className="d-flex justify-content-end gap-2">
//                   {totalUsage === 0 ? (
//                     <Button
//                       variant="warning"
//                       onClick={() => openModal("delete")}
//                       disabled={deleting}
//                     >
//                       Delete
//                     </Button>
//                   ) : (
//                     <Button
//                       variant="warning"
//                       onClick={() => openModal("update")}
//                       disabled={updating || !newSkuId || !newProductName}
//                     >
//                       {updating ? (
//                         <Spinner animation="border" size="sm" />
//                       ) : (
//                         "Update"
//                       )}
//                     </Button>
//                   )}
//                   <Button
//                     className="btn-cancel-custom"
//                     onClick={() => setShow({ show: false })}
//                   >
//                     Cancel
//                   </Button>
//                 </div>
//               </div>
//             </>
//           ) : (
//             <div className="empty-state">
//               <IconBoxOff size={48} stroke={1.2} />
//               <p className="mt-3 mb-0">No product data available.</p>
//             </div>
//           )}
//         </Modal.Body>

//         <Modal.Footer></Modal.Footer>
//       </Modal>
//     </>
//   );
// }

// export default UpdateProductsPopup;
